var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineVideoTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 .24 0 .49-.02.72-.03.3-.24.56-.53.65a.744.744 0 0 1-.8-.25 3.716 3.716 0 0 0-2.9-1.37c-.85 0-1.68.29-2.34.82-.9.71-1.41 1.77-1.41 2.93 0 .67.19 1.34.54 1.93.22.37.51.7.84.96.24.19.34.51.25.8-.09.29-.34.5-.65.53-.23.03-.48.03-.73.03H9zM2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h5.03c-.01-.01-.02-.03-.03-.04-.5-.82-.76-1.76-.76-2.71 0-1.62.72-3.11 1.98-4.1 1.68-1.36 4.23-1.48 6.02-.38V9c0-4.61-1.64-6.25-6.25-6.25H9C4.39 2.75 2.75 4.39 2.75 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.52 7.86c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h18.96a.749.749 0 1 1 0 1.5H2.52z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.77 6.97V2.11c0-.41.34-.75.75-.75s.75.34.75.75v4.86c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM14.73 6.52V2.11c0-.41.34-.75.75-.75s.75.34.75.75v4.41c0 .42-.33.75-.75.75-.41 0-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.26 22.62c-.02-.02-.05-.03-.07-.05-.47-.38-.87-.83-1.18-1.36-.5-.82-.76-1.76-.76-2.71 0-1.62.72-3.11 1.98-4.1.92-.74 2.08-1.15 3.27-1.15 1.59 0 3.07.7 4.06 1.93.76.92 1.19 2.1 1.19 3.32 0 .95-.26 1.88-.76 2.71-.29.48-.64.89-1.04 1.24a5.19 5.19 0 0 1-3.45 1.3c-1.18 0-2.32-.4-3.24-1.13zm.89-1.21c.66.55 1.49.85 2.35.85.92 0 1.77-.32 2.46-.93.29-.25.54-.55.75-.88a3.8 3.8 0 0 0 .54-1.93c0-.87-.3-1.71-.85-2.37a3.709 3.709 0 0 0-2.9-1.38c-.85 0-1.68.29-2.34.82-.9.71-1.41 1.77-1.41 2.93 0 .67.19 1.34.54 1.93.21.33.47.64.78.9.03.02.05.04.08.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.32 20.14-1.11-1.11a.755.755 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l.6.6 1.87-1.73c.3-.28.78-.26 1.06.04s.26.78-.04 1.06l-2.4 2.22c-.14.13-.32.2-.51.2s-.38-.07-.53-.22z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineVideoTick);
export default __webpack_public_path__ + "static/media/vuesax-outline-video-tick.0c1e7d2249f14f00eca964709fdbe87a.svg";
export { ForwardRef as ReactComponent };